import axios from "axios";
import { API_URL } from "shared/utils/constants";
import { getToken, clearToken } from "features/auth/services/auth";
import { ROUTES } from "shared/routes/routes";

if (!API_URL) {
    throw new Error("[config] REACT_APP_API_URL não está definido. Verifique o arquivo .env.");
}

const api = axios.create({
    baseURL: API_URL,
    withCredentials: true,
});

api.interceptors.request.use(
    (config) => {
        const token = getToken();

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
        // Erro de validação automática do [ApiController] (400) não tem campo "message",
        // só "errors: { Campo: [\"mensagem\"] }" — sem isso cai sempre no genérico abaixo.
        const firstValidationError = Object.values(error.response?.data?.errors ?? {})[0]?.[0];
        const errorMessage = error.response?.data?.message || firstValidationError || "Erro inesperado. Tente novamente.";
        const requestUrl = error.config?.url;

        // Só bloqueia o erro se não for a rota de login
        if (status === 401 && 
            !requestUrl.includes(ROUTES.login) &&
            !requestUrl.includes(ROUTES.signup)
        ) {    
            clearToken();
            window.location.href = ROUTES.login; 
            return new Promise(() => {});  
        }

        if (status === 403) {
            return Promise.reject({ status, message: errorMessage });
        }

        console.error(`Erro (${status}): ${errorMessage}`);

        return Promise.reject({ status: status || 500, message: errorMessage });
    }
);

export default api;